export default {
    book: "予約 {product}",
    age_limit: "{age} のみ",
    change_plan: "計画の変更",
    upgrade_product: "アップグレード製品",
    upgrade: "アップグレード",
    cancel_upgrade: "アップグレードのキャンセル",
    choose_product: "{product}を選択してください",
    days: "{count} 日 | {count} 日",
    login_register: "ログイン/登録",
    current: "現在",
    keyless_benefits: {
        label: '車に直行 {0}',
        highlight: 'レンタルサービス™',
        list: {
            cant_lose_the_key: '全額保険',
            zero_excess: 'ゼロ過剰',
            phone_as_a_key: '電話をキーとして',
            straight_to_car: '待ち時間なし',
            no_queues: '行列なし',
            online_id_check: 'オンラインIDチェック',
            self_checkout: 'セルフチェックアウト',
        },
    },
}
